<template>
  <div id="burberry-auth" />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('account', ['burberrylogin']),
  },
  mounted() {
    const { code, error } = this.$route.query;
    if (code) {
      this.burberrylogin({ code });
    } else {
      alert(`Login failed: ${error}`);
    }
  },
};
</script>

<style>
</style>
